/*
Sample Response
{
    "id": "8bc1ab14-47c8-46e6-8202-69df7843f01d",
    "course": "Cambridge Business Sustainability Management online short course",
    "durationWeeks": 8,
    "duration": "8 weeks (excluding orientation)",
    "effort": "8–12 hours per week",
    "currency": "ZAR",
    "price": "39323.0",
    "display_price": "R39,323 ZAR",
    "regCloseDate": "2025-09-30T00:00:00Z",
    "startDate": "2025-10-08T00:00:00Z",
    "endDate": "2025-10-14T00:00:00Z"
}

More info on API
https://docs.google.com/document/d/1keuLldO9Om6-ONKTHgNYQ7GeVLBxmT-mUfqr62IqoNI/edit?tab=t.0

[USD, GBP, ZAR, EUR, AED, SGD, HKD, SAR, INR, CAD, CHF, AUD] are the supported currencies

If outside of the supported geolocations USD will be displayed:

*/

import newrelic from "../monitoring/newrelic";

export interface GetSmarterCourseDetails {
  id: string;
  course: string;
  durationWeeks?: number;
  duration?: string;
  effort?: string;
  currency: string;
  price: string;
  display_price: string;
  regCloseDate?: string;
  startDate?: string;
  endDate?: string;
}

export function getCheckoutURL(
  course: GetSmarterCourseDetails,
  couponCode: string,
  externalIdentifier?: string | null,
): string {
  const encodedUUID = Buffer.from(course.id).toString("base64");

  return `https://getsmarter.com/titan/api/v1/cart/add_items?promo_code=${couponCode}&uuids[]=${externalIdentifier}&utm_source=edx&utm_medium=referral&variation=about_page&page_type=about_page&external_link=true&index=product&position=2&said=${encodedUUID}`;
}

export async function getPricing(
  courseSlug: string,
  ipAddress: string,
): Promise<GetSmarterCourseDetails | null> {
  // Base64 encode the ip of the request

  if (!courseSlug || !ipAddress) {
    newrelic.noticeError(new Error("Missing Smarter Pricing API mapping"), {
      courseSlug,
    });
    return null;
  }

  try {
    const encodedIp = Buffer.from(ipAddress).toString("base64");
    const url = `https://www.getsmarter.com/products/${courseSlug}.json?ip=${encodedIp}`;
    const response = await fetch(url, { method: "GET" });
    if (response.ok) {
      const body = await response.json();
      return body;
    }
  } catch (error) {
    newrelic.noticeError(error as Error, { courseSlug });
  }

  return null;
}
